import { useTheme, Button } from "@mui/material";
import React from "react";

import Google from "./Google";

import RailsRoutes from '../RailsRoutes';

import { tss } from 'tss-react';

import styles from './styles';

export default function DividerSocialBtn({text}) {
    const theme = useTheme();
    const { classes } = tss.create(styles(theme))();

    if (!theme.configuration.socialAuthEnabled) {
      return false;
    }

    return (
      <>
        <p className={classes.divider}>
          <span className={classes.dividerHr}/>
          <span className={classes.dividerText}>{text}</span>
        </p>
        <div className={classes.flex}>
          <Button variant="outlined" color="primary" href={RailsRoutes.user_google_oauth2_omniauth_authorize_path()}
                  data-method="POST">
            <Google/>
            Google
          </Button>
        </div>
      </>
    );
}
